import { useParams } from 'react-router-dom';
import Tabela from '../../../Componentes/Utils/Tabela';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useModal } from '../../../contexts/ModalContext';
import PreencherItem from './PreencherItem';

import useApi from "../../../hooks/useApi";
const TableCells = styled.td`
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
`

const TabelaItens = () => {
    const api = useApi();


    const { id } = useParams();
    const { openModal, isModalOpen, closeModal } = useModal();

    const [ loading, setLoading ] = useState( true );

    const [ itens, setItens ] = useState([])
    const [ selectedItem, setSelectedItem ] = useState( null );

    const fetchItens = async () => {

        setLoading( true );

        try{

            const { data } = await api.post('/Painel/API/Checklist/GetItensById/', {
                "id": id
            })

            console.log(data);
            setItens(data);

        }catch( e ){
            console.error(e);
        }finally{
            setLoading(false);
        }

    }

    useEffect(() => {

        if( !id ){
            return;
        }

        fetchItens();

    }, [ id ])

    const openItem = ( id ) => {

        setSelectedItem( id );
        openModal('itemForm')

    }

    const closeItem = () => {

        setSelectedItem( null );
        closeModal()

    }

    return(
        <>
            <Tabela loading={loading} >
                <thead>
                    <tr>
                        <th>ITEM</th>
                        <th>STATUS</th>
                    </tr>
                </thead>
                <tbody>
                    {itens.map((obj)=>(
                        <tr
                            key={ obj.id }
                            onClick={() => openItem( obj.id )}
                        >
                            <td>{ obj.item }</td>
                            <TableCells align="center" >{ obj.conforme ? obj.conforme : '-' }</TableCells>
                        </tr>
                    ))}
                </tbody>
            </Tabela>
            {isModalOpen('itemForm')&&(
                <PreencherItem
                    id={ selectedItem }
                    fetchSuccess={ fetchItens }
                />
            )}
        </>
    )
}

export default TabelaItens;